<template>
  <div>
    <LazyDialog v-if="shouldShow" />

    <ClientOnly>
      <ToastGroup />
    </ClientOnly>

    <main class="main--no-padding">
      <Suspense suspensible>
        <slot />
      </Suspense>
    </main>

    <div>
      <GlobalModals />
    </div>

    <ClientOnly>
      <LazyTrustBadge />
    </ClientOnly>
  </div>
</template>

<script setup>
await useCart()
await useWishlist()
const { shouldShow } = useDialog()
</script>
<style lang="scss" scoped>
main {
  background-color: var(--grey-lightest);
}
</style>
